<template>
  <div class="login">
    <h2>E-Surprise BO</h2>
    <h3>Sign In</h3><br/>
    <input type="text" placeholder="Email" v-model="email"/><br/>
    <input type="password" placeholder="Password" v-model="password"/><br/>
    <button @click="signIn()">Sign In</button>
  </div>
</template>

<script>
import Firebase from 'firebase/app'
import 'firebase/auth'
export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signIn: function () {
      console.log('signing in...')
      let self = this
      Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        function (user) {
          console.log('User had been signed in')
          self.$router.replace('invoices')
        },
        function (err) {
          console.error('Error signing in: ' + err)
          alert('Error signing in: ' + err)
        }
      )
    }
  }
}
</script>

<style scoped>
.login {
  margin-top: 40px;
}
input {
  margin: 10px 0;
  width: 20%;
  padding: 15px;
}
button {
  margin-top: 20px;
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue